import React, { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { GenericObject, getApplicationId, getIsPortal } from '@fnol/library/src/lib';
import { FormControl, FormHelperText } from '@mui/material';
import { getCauses } from '../../rpc/actions';
import { useApi } from '@fnol/library/src/hooks';
import { GroupSelect } from '@fnol/library/src/components';
import { policiesProperties, translations } from '../../lib/consts';
import { prepareCausesList } from '../../lib/helpers';

const CauseType = () => {
    const { values, errors, touched, handleChange, setFieldValue } = useFormikContext<GenericObject>();

    let insuranceMethod: number;
    let policyNumber: string;
    if (getIsPortal(getApplicationId())) {
        insuranceMethod = values.activePolicy[policiesProperties.insuranceMethodIDFromBE];
        policyNumber = values.policyNumberAPI;
    } else {
        insuranceMethod = values.insuranceMethod;
        policyNumber = values.policyNumber;
    }
    const { response: causes, fetchMethod: fetchCauses } = useApi(() =>
        getCauses(insuranceMethod, policyNumber, values.publicUtility),
    );
    const [preparedCauses, setPreparedCauses] = useState<any>();

    const handleChangeCause = (e: { target: { value: any } }): any => {
        const selectedCause = preparedCauses?.find((item: any) => item.id === e.target.value);
        setFieldValue('cause', e.target.value);
        setFieldValue('causeName', selectedCause?.text);
        handleChange(e);
    };

    useEffect(() => {
        fetchCauses();
    }, []);

    useEffect(() => {
        Array.isArray(causes?.data?.data) && setPreparedCauses(prepareCausesList(causes.data.data));
    }, [causes]);

    return (
        <FormControl>
            <Field
                name="cause"
                id="cause"
                label={translations.CAUSE_TYPE}
                items={preparedCauses || []}
                value={values.cause}
                as={GroupSelect}
                onChange={handleChangeCause}
                error={!!(touched.cause && errors.cause)}
                required
            />
            {touched.cause && errors.cause ? (
                <FormHelperText error={true}>
                    <>{errors.cause}</>
                </FormHelperText>
            ) : null}
        </FormControl>
    );
};

export default CauseType;
